module.exports = __webpack_public_path__ + "static/media/chat-icon.d4450732.png";